import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeAccount, setActiveAccount] = useState(localStorage.getItem('pp_active_account') || null);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem('pp_token');
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
      if (data.role === 'owner') { setActiveAccountId(data.id); }
    } catch (e) { localStorage.removeItem('pp_token'); }
    setLoading(false);
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const setActiveAccountId = (id) => {
    if (id) { localStorage.setItem('pp_active_account', id); setActiveAccount(id); }
    else { localStorage.removeItem('pp_active_account'); setActiveAccount(null); }
  };

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('pp_token', data.token);
    sessionStorage.removeItem('pp_entry_applied');
    setUser(data.user);
    if (data.user.role === 'owner') setActiveAccountId(data.user.id);
    else setActiveAccountId(null);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem('pp_token', data.token);
    setUser(data.user);
    if (data.user.role === 'owner') setActiveAccountId(data.user.id);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('pp_token');
    localStorage.removeItem('pp_active_account');
    sessionStorage.removeItem('pp_entry_applied');
    setUser(null); setActiveAccount(null);
    window.location.href = '/';
  };

  const updateProfile = async (payload) => {
    const { data } = await api.patch('/auth/me', payload);
    setUser(data);
    return data;
  };

  const changePassword = async (current_password, new_password) => {
    await api.post('/auth/change-password', { current_password, new_password });
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, logout, updateProfile, changePassword, activeAccount, setActiveAccountId, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
};
